<app-form-modal
  title="{{ (patient$ | async)?.firstName | titlecase }}, you're one step away!"
  [(visible)]="displayHipaaVerifyModal"
  formId="hipaaForm"
  [submitLabel]="(updatePatientState$ | async)?.isUpdating ? 'Activating...' : 'Activate Now'"
  [disabled]="(updatePatientState$ | async)?.isUpdating"
  [noCancel]="true"
>
  <p class="subtitle">For your security, please verify the following information.</p>
  <div *ngIf="errorMessage">
    <app-message severity="error" data-cy="hipaa-error-message">
      {{ errorMessage }}
    </app-message>
  </div>
  <form class="mb-6" [formGroup]="hipaaForm" (ngSubmit)="onSubmit()" id="hipaaForm" data-cy="hipaa-form">
    <div class="grid m-0">
      <app-form-field
        class="col-12 p-0"
        [control]="asFormControl(hipaaForm.get('lastName'))"
        name="lastName"
        label="Last Name"
        type="input"
      ></app-form-field>
      <app-form-field
        class="col-12 p-0 sm:col-6 sm:pr-3"
        [control]="asFormControl(hipaaForm.get('zipCode'))"
        name="zipCode"
        label="Home Zip Code"
        type="input"
      ></app-form-field>
      <app-form-field
        class="col-12 p-0 sm:col-6 sm:pl-3"
        [control]="asFormControl(hipaaForm.get('dob'))"
        name="dob"
        placeholder="mm/dd/yyyy"
        label="Date of Birth"
        type="calendar"
      ></app-form-field>
    </div>
    <app-form-field
      [control]="asFormControl(hipaaForm.get('acceptedTermsAndConditions'))"
      name="acceptedTermsAndConditions"
      errorLabel="Confirmation"
      [noMargin]="true"
      type="checkbox-binary"
      ><span class="p3"
        >I agree to
        <a [href]="termsAndConditionsUrl" target="_blank">Terms & Conditions</a>
        and
        <a [href]="privacyUrl" target="_blank">Privacy Practices</a>.
      </span>
    </app-form-field>
    <app-form-field
      [control]="asFormControl(hipaaForm.get('consentedToMarketing'))"
      name="consentedToMarketing"
      errorLabel="Confirmation"
      type="checkbox-binary"
      [noMargin]="true"
      [noCheckboxMargin]="true"
      label="I'd like to receive educational and promotional emails from CCS"
    ></app-form-field>
  </form>
</app-form-modal>
